import { Field, FieldProps } from "formik";

import {
  RadioButtonGroup,
  RadioButtonGroupProps,
  RadioButtonOption,
} from "../base";
import { ErrorMessage } from "../ErrorMessage";
import { Path } from "./types";

type FormRadioButtonGroupProps<T, V extends string | number> = {
  name: Path<T>;
  options: RadioButtonOption<V>[];
  label?: string;
} & Omit<RadioButtonGroupProps<V>, "onChange" | "value">;

export const FormRadioButtonGroup = <T, V extends string | number>({
  name,
  ...rest
}: FormRadioButtonGroupProps<T, V>) => {
  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => (
        <div className="flex flex-col gap-1.5">
          <RadioButtonGroup {...field} {...rest} />
          {meta.touched && meta.error && <ErrorMessage text={meta.error} />}
        </div>
      )}
    </Field>
  );
};
